import React from 'react';
import AdminLayout from 'Components/Layout/AdminLayout';
import styled from 'styled-components';
import AdminFrontpage from 'Components/AdminPage/AdminFrontpage';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const AdminPanel = () => {
  return (
    <AdminLayout>
      <ContentContainer>
        <AdminFrontpage />
      </ContentContainer>
    </AdminLayout>
  );
};
export default AdminPanel;
